function f(t, n, i) {
  for (var e = i - 1, r = t.length; ++e < r; )
    if (t[e] === n)
      return e;
  return -1;
}
export {
  f as default
};
